import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Logo from '../../../assets/app/logo.png'
import { SingleTutor } from '../index'
import { Link } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import { TutorAvailability, TutorBackground, TutorPricing, TutorProfileStep } from "./tutor-steps";
import { ProfileRole, ProfileStatusEnum, selectTutorProfile } from "../../../store/profile/profileSlice";
import { getProfile } from "../../../store/profile/profileActions";
import { defaultTutorLanguages, defaultWeekDays } from "./tutor-defaults";
import { StepIndicator } from "./step-indicator";

const TUTOR_SWITCH_STEPS = [
    { id: 3, label: "Profile" },
    { id: 4, label: "Background" },
    { id: 5, label: "Availability" },
    { id: 6, label: "Pricing" },
];

const SwitchTutorForm = ({ currentStep, setCurrentStep }) => {
    const { user } = useSelector((state) => state.auth);
    const tutorProfile = useSelector(selectTutorProfile);
    const dispatch = useDispatch();
    const initialValues = {
        firstName: user.firstName,
        lastName: user.lastName,
        userId: user._id,
        speak: defaultTutorLanguages.speak,
        teach: defaultTutorLanguages.teach,
        tutorId: "",
        education: [],
        experience: [],
        certificates: [],
        days: defaultWeekDays,
        prices: [],
        avatar: user.avatar || null
    }

    const [activeTab, setActiveTab] = useState(0);

    const methods = useForm({
        defaultValues: initialValues
    })

    useEffect(() => {
        dispatch(getProfile({ role: ProfileRole.TUTOR }))
            .unwrap()
            .then((data) => {
                if (!data) return;
                const { experience, certificate, education, speak, teach, ...rest } = data;
                if (data.status === ProfileStatusEnum.waitForApproval) {
                    setCurrentStep(10);
                    return;
                }
                methods.reset({
                    ...methods.getValues(),
                    ...rest,
                    speak: speak?.length ? speak : defaultTutorLanguages.speak,
                    teach: teach?.length ? teach : defaultTutorLanguages.teach,
                    days: methods.getValues("days")?.length ? methods.getValues("days") : defaultWeekDays,
                    education: [],
                    experience: [],
                    certificates: [],
                });
            });
    }, [])

    const data = methods.watch();
    const getProfileData = () => {
        if (tutorProfile?.education?.length || tutorProfile?.experience?.length || tutorProfile?.certificate?.length) {
            return {
                ...data,
                education: [...(data.education || []), ...(tutorProfile.education || [])],
                experience: [...(data.experience || []), ...(tutorProfile.experience || [])],
                certificates: [...(data.certificates || []), ...(tutorProfile.certificate || [])],
            }
        }
        return data;
    }

    return (

        <FormProvider {...methods}>

            <div className='w-full xl:w-1/2 px-2 xl:px-0'>
                <div className="max-w-[600px] mx-auto relative flex justify-between items-center">
                    <img className='my-10' src={Logo} alt="Logo" />
                    <Link to="/" className="no-underline text-nt-blue flex items-center"><FiArrowLeft size={18} className="mr-1" />Dashboard</Link>
                </div>
                {currentStep !== 10 && (
                    <StepIndicator steps={TUTOR_SWITCH_STEPS} currentStep={currentStep} />
                )}
                <div className="max-w-[600px] mx-auto">
                    {currentStep === 3 && <TutorProfileStep setActiveTab={setActiveTab} setCurrentStep={setCurrentStep} previousStep={false} />}
                    {currentStep === 4 && <TutorBackground setActiveTab={setActiveTab} setCurrentStep={setCurrentStep} />}
                    {currentStep === 5 && <TutorAvailability setActiveTab={setActiveTab} setCurrentStep={setCurrentStep} />}
                    {currentStep === 6 && <TutorPricing setActiveTab={setActiveTab} setCurrentStep={setCurrentStep} />}
                    {currentStep === 10 && (
                        <div className="w-full text-center text-nt-blue">
                            <p style={{ fontSize: "50px" }}>🎉</p>
                            <p className="mt-4">
                                Welcome to our diverse language platform!<br />
                                Your account is under review!
                            </p>
                        </div>
                    )}
                </div>
            </div>
            <div className="hidden xl:block w-1/2 bg-nt-grey-light h-screen fixed top-0 right-0 p-[20px] overflow-auto text-nt-blue">
                <SingleTutor profile={getProfileData()} activeTab={activeTab} setActiveTab={setActiveTab} />
            </div>
        </FormProvider>
    );
}

export { SwitchTutorForm }
